import axios from "axios";
import apiURI from "../Api";

export default class SpecialCustomerService {
  async postRegisterSpecialCustomer(
    referee,
    username,
    email,
    documentNumber,
    fname,
    lname,
    password,
    currency,
    language,
    coupon,
    country,
    internationalCode,
    localCode,
    phoneNumber,
    latitude,
    longitude,
    idProductCart
  ) {
    const registerSpecialCustomer = {
      cupominvite: coupon,
      referee: {
        username: referee,
      },
      latitude: typeof latitude === "string" ? parseFloat(latitude) : latitude,
      longitude: typeof longitude === "string" ? parseFloat(longitude) : longitude,
      currency: currency,
      idProductCart: idProductCart || null,
      specialcustomer: {
        originRegister: JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))
          ? "MOBILE"
          : "WEB",
        documentNumber: null,
        email: email,
        firstname: fname,
        password: password,
        surname: lname,
        username: username,
        language: language,
        internationalCode: internationalCode,
        localCode: localCode,
        phoneNumber: phoneNumber,
        country: country,
      },
    };

    const response = await axios.post(
      `${apiURI}/specialcostumer/register`,
      registerSpecialCustomer
    );
    return response.data;
  }
}
